import Vue from "vue";
import Buefy from "buefy"
import PendingOrderPayment from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(PendingOrderPayment)

if(document.getElementById("pendingOrderPaymentApp")){
    new Vue({
        render:h=>h(
            PendingOrderPayment,{
                props:{
                    orderPayUrl:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("order-pay-url"),
                    mpChannel:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("mp-channel"),
                    cashChannel:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("cash-channel"),
                    mpPubKey:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("mp-pub-key"),
                    transferChannel:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("transfer-channel"),
                    paypalChannel:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("paypal-channel"),
                    channelList:document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("channel-list"),
                    ppMinOrder: document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("pp-min-order"),
                    mpMinOrder: document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("mp-min-order"),
                    usdReports: document.getElementById("pendingOrderPaymentApp")
                        .getAttribute("usd-reports")
                }
            }
        )
    }).$mount("#pendingOrderPaymentApp")
}